import { useFetcher, useSearchParams } from '@remix-run/react';
import { useEffect, useState } from 'react';

import type { Post } from '~/interfaces/post';
import type { Publication } from '~/interfaces/publication';

import getContentTagIds from '~/utils/getContentTagIds';

const useFilterPosts = ({
  initialPosts,
  initialPagination,
  publication,
}: {
  initialPosts: any;
  initialPagination: any;
  publication: Publication;
}) => {
  const fetcher = useFetcher<{
    posts?: Post[];
  }>();
  const totalPages = initialPagination.total_pages;
  const [posts, setPosts] = useState(initialPosts);
  const [page, setPage] = useState(initialPagination.page);
  const fetchedData = fetcher?.data;

  const [searchParams] = useSearchParams();
  const q = searchParams.get('q');
  const tags = searchParams.getAll('tags');

  const fetchPosts = () => {
    const searchParams: any = new URLSearchParams();
    searchParams.append('page', page + 1);

    if (q) {
      searchParams.append('q', q);
    }

    if (tags.length) {
      searchParams.append('content_tags', getContentTagIds(tags, publication?.content_tags));
    }

    fetcher.load(`/posts?${searchParams.toString()}`);
  };

  useEffect(() => {
    if (posts) {
      setPage(1);
      setPosts(initialPosts);
    }
  }, [initialPosts]);

  useEffect(() => {
    if (fetchedData) {
      setPage(page + 1);
      setPosts(posts.concat(fetchedData?.posts));
    }
  }, [fetchedData]);

  return {
    postsToRender: posts,
    showLoadMore: page + 1 <= totalPages,
    isLoading: fetcher?.state !== 'idle',
    postsFetcher: fetcher,
    fetchPosts,
  };
};

export default useFilterPosts;
